import {
    CertificateListPreProcessingArguments, CertificateListPreProcessingResult,
    SignatureProcessStartArguments, StartSessionStateResult,
    BatchProcessingArguments, SessionStateResult,
    SignerSessionHttpServices
} from "./http-models";

/** Classe para intermediar mensagens com webservice de assinatura digital
 */
export class DefaultSignerSessionHttpServices implements SignerSessionHttpServices
{
    /** construtor
     * @param baseUri  Url do webservice de assinatura digital
     */
    constructor(
        protected baseUri: string
    ) { }

    /** Realiza pré-processamento dos certificados, aplicando filtros para retornar apenas certificados válidos para utilização
     * @param payload  Parâmetros para execução do serviço
     * @returns Promise contendo lista de certificados retornados pelo serviço
     */
    processCertificates(payload: CertificateListPreProcessingArguments) : Promise<CertificateListPreProcessingResult> {
        const uri = this.getProcessCertificatesUri(payload);
        return this.runFetch(uri, payload);
    }

    /** Cria sessão de assinatura
     * @param payload  Parâmetros para execução do serviço
     * @returns Promise com sessão de assinatura criada
     */
    startSession(payload: SignatureProcessStartArguments) : Promise<StartSessionStateResult> {
        const uri = this.getStartSessionUri(payload);
        return this.runFetch(uri, payload);
    }

    /** Envia lote de inputs para assinatura
     * @param payload  Parâmetros para execução do serviço
     * @returns Promise com assinaturas realizadas
     */
    sendBatch(payload: BatchProcessingArguments) : Promise<SessionStateResult> {
        const uri = this.getSendBatchUri(payload);
        return this.runFetch(uri, payload);
    }

    /** Converte json recebido para objeto
     * @param uri      Url do serviço chamado
     * @param payload  Target do objeto a ser deserializado
     * @returns Promise com o objeto deserializado
     */
    protected runFetch<T, U>(uri: string, payload: T) : Promise<U> {
        return fetch(uri, this.buildFetchSettings(uri, payload))
                .then(resp => resp.text())
                .then(respText => {
                    try { return <U>JSON.parse(respText); }
                    catch (e) { return Promise.reject<U>(respText); }
                });
    }

    /** Monta configurações para requisições ao serviço de assinatura digital
     * @param uri      Url do serviço
     * @param payload  Parâmetros para execução do serviço
     */
    protected buildFetchSettings<T>(uri: string, payload: T) : RequestInit {
        return {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(payload)
        };
    }

    /** Busca rota para operação de pré-processamento de certificados
     * @param payload Parâmetros para execução do serviço
     * @returns Url completa para serviço de pré-processamento de certificados
     */
    protected getProcessCertificatesUri(payload: CertificateListPreProcessingArguments) : string {
        return this.baseUri + "/process-certs";
    }

    /** Busca rota para operação de criação de sessão de assinatura
     * @param payload Parâmetros para execução do serviço
     * @returns Url completa para serviço de criação de sessão de assinatura
     */
    protected getStartSessionUri(payload: SignatureProcessStartArguments) : string {
        return this.baseUri + "/start";
    }

    /** Busca rota para operação de assinatura de lote de inputs 
     * @param payload Parâmetros para execução do serviço
     * @returns Url completa para serviço de assinatura de lote de assinaturas
     */
    protected getSendBatchUri(payload: BatchProcessingArguments) : string {
        return this.baseUri + "/batch";
    }
}



// WEBPACK FOOTER //
// ./lib/default-http-services.ts